import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

export class SalesGroupName extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: string): SalesGroupName {
    if (!(value.length > 0)) {
      throw new Error('名前が入力されていません');
    }
    return new SalesGroupName(value);
  }

  /** ラベル */
  static get label(): string {
    return 'グループ名';
  }

  /** プレースホルダー */
  static get placeholder(): string {
    return 'グループ名';
  }

  /** バリデーションルール */
  static get validationRule() {
    return {
      /** 必須 */
      required: '必須項目です',
    };
  }

  /** キー */
  static get key(): string {
    return 'name';
  }

  /** タイプ */
  static get type(): string {
    return 'text';
  }

  /** 文字列にする */
  override toString() {
    return this.value;
  }
}
